/*
Defines the custom element <ravel-visualizer-2>
*/

import { RavelVisualizer2 } from './src/RavelVisualizer2.js';


customElements.define('ravel-visualizer-2', RavelVisualizer2);
